import React from 'react';

function Projects() {
  return (
    <section id="projects" aria-labelledby="projects-label">
      <div className="projects-heading revealable">
        <h2 id="projects-label">Projects</h2>
        <p>Selected projects demonstrating applied financial analysis and decision-support tools.</p>
      </div>

      <div className="project-gallery revealable">
        <div className="project-card from-left delay-1">
          <h3>Financial Dashboard</h3>
          <p>
            Designed an interactive Python and Streamlit dashboard to analyse market performance and trends, enabling faster insight generation and scenario interpretation for investment analysis.
          </p>
          <a
            href="https://capital-market-performance.streamlit.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Project
          </a>
        </div>

        <div className="project-card from-right delay-2">
          <h3>Equity Valuation Tool</h3>
          <p>
            Built a valuation framework using Excel and Python, incorporating DCF and comparable company analysis to assess startup and equity investment opportunities.
          </p>
          <a
            href="/products"
            target="_blank"
            rel="noopener noreferrer"
          >
            Coming Soon And More
          </a>
        </div>
      </div>
    </section>
  );
}

export default Projects;